<!--下载中心div-->
<template>
    <div id="downloadDiv">
        <img src="../../assets/download.png">
        <div>
            <span>下载中心</span>
            <p>Download Center</p>
        </div>
    </div>
</template>
<script>
export default {
  name: "downloadDiv"
};
</script>
<style lang="scss" scoped>
#downloadDiv {
  height: 164px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    180deg,
    rgba(78, 84, 200, 1) 0%,
    rgba(143, 148, 251, 1) 100%
  );
  border-radius: 3px;
  img{
    width: 70px;
    height: 70px;
  }
  div{
    text-align: center
  }
  span{
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: normal;
    font-size: 36px;
    color: #F5F5F5;
    letter-spacing: 6px;
  }
  p{
    padding: 2px;
    opacity: 0.5;
    font-family: 'Arial Normal', 'Arial';
    font-style: normal;
    font-size: 18px;
    color: #F5F5F5;
  }
}
</style>

